function ExceptionWrongPassword() {
    const error = new Error();
    error.code = 401;
    return error;
}

ExceptionWrongPassword.prototype = Object.create(Error.prototype);

export default ExceptionWrongPassword;
